import { useQuery } from '@tanstack/react-query'

import api from '@/api/client'

export const enum TimerQueryKeys {
  'TIMER' = 'timer'
}

const getTimer = async () => {
  const response = await api.v2TimersList()
  return response.timer
}

export const useTimer = () => {
  return useQuery({
    queryKey: [TimerQueryKeys.TIMER],
    queryFn: () => getTimer(),
    refetchOnMount: true,
    staleTime: 60_000, // 1 minute
    meta: { scope: 'news' }
  })
}
